(() => {
  if (window.storefrontAccordionMotion) return;

  const selector = [
    'details.product-editorial__details',
    'details.product-editorial__extras',
    'details.collection-catalog__description',
    'details.shipping-editorial__terms',
    'details.disclosures__details',
    '.accordion details',
    'details.facets__disclosure-vertical',
    'details#Details-CartDrawer',
  ].join(',');
  const animations = new Map();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function sync(details, expanded) {
    details.dataset.accordionExpanded = String(expanded);
    details.querySelector(':scope > summary')?.setAttribute('aria-expanded', String(expanded));
  }

  function prepare(details) {
    if (details.hasAttribute('data-accordion-expanded')) return;
    const summary = details.querySelector(':scope > summary');
    const caret = summary?.querySelector('.icon-caret');
    const icon = details.matches('.product-editorial__details')
      ? caret?.closest('.svg-wrapper')
      : caret || (details.matches('.collection-catalog__description') && summary?.querySelector('[aria-hidden="true"]'));
    if (icon) icon.setAttribute('data-accordion-icon', '');
    sync(details, details.open);
  }

  function cancel(details) {
    const state = animations.get(details);
    if (!state) return;
    animations.delete(details);
    state.animation.onfinish = null;
    state.animation.cancel();
    state.restore();
    details.removeAttribute('data-accordion-animating');
  }

  function finish(details, expanded) {
    cancel(details);
    details.open = expanded;
    sync(details, expanded);
  }

  function setOpen(details, expanded, animate = true) {
    if (!details?.matches(selector)) return;
    prepare(details);
    const startHeight = details.getBoundingClientRect().height;
    cancel(details);
    const summary = details.querySelector(':scope > summary');
    const content = Array.from(details.children).filter(element => !element.matches('summary, script, style, link'));
    if (!expanded && content.some(element => element.contains(document.activeElement))) {
      summary?.focus({ preventScroll: true });
    }

    sync(details, expanded);
    details.open = expanded;
    const endHeight = details.getBoundingClientRect().height;
    if (!animate || reducedMotion.matches || !details.animate || Math.abs(startHeight - endHeight) < 1) return;

    details.open = true;
    const previous = content.map(element => ({ element, inert: element.inert, hidden: element.getAttribute('aria-hidden') }));
    if (!expanded) {
      content.forEach(element => {
        element.inert = true;
        element.setAttribute('aria-hidden', 'true');
      });
    }
    details.setAttribute('data-accordion-animating', '');
    const animation = details.animate(
      [{ height: `${startHeight}px` }, { height: `${endHeight}px` }],
      { duration: 350, easing: 'cubic-bezier(.22,.61,.36,1)' }
    );
    const state = {
      animation,
      expanded,
      restore() {
        previous.forEach(({ element, inert, hidden }) => {
          element.inert = inert;
          if (hidden === null) element.removeAttribute('aria-hidden');
          else element.setAttribute('aria-hidden', hidden);
        });
      },
    };
    animations.set(details, state);
    animation.onfinish = () => {
      if (animations.get(details) === state) finish(details, expanded);
    };
  }

  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button > 0 || !(event.target instanceof Element)) return;
    const summary = event.target.closest('summary');
    const details = summary?.parentElement;
    if (!details?.matches(selector) || event.target.closest('a, button, input, select, textarea, label, [contenteditable="true"]')) return;
    event.preventDefault();
    setOpen(details, !(animations.get(details)?.expanded ?? details.open));
  });

  document.addEventListener('keyup', event => {
    if (event.key !== 'Escape' || !(event.target instanceof Element)) return;
    const details = event.target.closest('details');
    if (!details?.matches(selector) || !(animations.get(details)?.expanded ?? details.open)) return;
    event.preventDefault();
    event.stopPropagation();
    setOpen(details, false);
    details.querySelector(':scope > summary')?.focus({ preventScroll: true });
  }, true);

  document.addEventListener('toggle', event => {
    const details = event.target;
    if (!(details instanceof Element) || !details.matches(selector)) return;
    if (animations.has(details)) {
      if (!details.open) finish(details, false);
      return;
    }
    prepare(details);
    sync(details, details.open);
  }, true);

  document.addEventListener('shopify:block:select', event => {
    const details = event.target.closest('details') || event.target.querySelector('details');
    if (details?.matches(selector)) setOpen(details, true, false);
  });

  function finishAnimations() {
    animations.forEach((state, details) => finish(details, state.expanded));
  }
  window.addEventListener('resize', finishAnimations);
  reducedMotion.addEventListener('change', finishAnimations);
  window.storefrontAccordionMotion = { setOpen };
})();
